import { render, staticRenderFns } from "./SalesInvoices.vue?vue&type=template&id=6cd644de&scoped=true&"
import script from "./SalesInvoices.vue?vue&type=script&lang=js&"
export * from "./SalesInvoices.vue?vue&type=script&lang=js&"
import style0 from "./SalesInvoices.vue?vue&type=style&index=0&id=6cd644de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd644de",
  null
  
)

export default component.exports